export default __webpack_public_path__ + "static/media/hospital.052adc5e.png";